import React from "react";
import { useTranslation } from "react-i18next";
import Spacer from "../common/Spacer";

function Aboutus() {
  const { t } = useTranslation();
  const highlightBrand = (text) => {
    const parts = text.split(/(Aypin Otomat)/g);
    return parts.map((part, i) =>
      part === "Aypin Otomat" ? (
        <span key={i} className="brand-name">Aypin Otomat</span>
      ) : (
        part
      )
    );
  };

  return (
    <section id="contact" className="contact">
      <Spacer />
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>{t("HAKKIMIZDA")}</h2>
        </div>

        <div className="row">
          <div className="col-lg-5">
            <table className="">
              <tbody>
                <tr>
                  <td>
                    <img
                      src="assets/img/Aypinautomat/10.webp"
                      className="img-fluid"
                      alt="Hakkımızda"
                      title="Hakkımızda"
                      style={{borderRadius: "5px" }}
                      width={"100%"}
                      height={"100%"}
                      loading="lazy"
                      decoding="async"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="col-lg-7">
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              {highlightBrand(
                t("About.Para1")
              )}
              <br />
              <br />
              {highlightBrand(
                t("About.Para2")
              )}
              <br />
              <br />
              {highlightBrand(
                t("About.Para3")
              )}
            </p>
          </div>
          <br />
          <div className="col-lg-12">
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              <br />
              {highlightBrand(
                t("About.Para4")
              )}
              <br />
              <br />
              {highlightBrand(
                t("About.Para5")
              )}
              <br />
              <br />
              {highlightBrand(
                t("About.Para6")
              )}
              <br />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Aboutus;
